import GLightbox from 'glightbox'

const realizations = document.querySelector('.realizations');

if (realizations) {
    const subpageLightbox = GLightbox();
}